import { lazy, Suspense } from 'react'

import { useFvNavigate } from '@fv/client-components'

import { Loading } from '@/components/Loading'
import { ShipperSlider } from '@/components/ShipperSlider'
import { routes } from '@/routes'

import { useUploadView } from './hooks'
import { CONFIRM_UPLOAD_EXIT } from './utils'

const ShipmentUploadApp = lazy(() => import('./ShipmentUploadApp'))

export const ShipmentUploadSlider = () => {
  const { isOpen, mode } = useUploadView()
  const navigate = useFvNavigate()

  const closeUploadSlider = () => {
    navigate('/pending')
  }

  const closeNewUpload = (doConfirm = false) => {
    if (doConfirm && !window.confirm(CONFIRM_UPLOAD_EXIT)) {
      return
    }

    closeUploadSlider()
  }

  const handleClosePanel = () => {
    if (mode === 'new') {
      closeNewUpload(true)
      return
    }

    if (mode === 'view') {
      navigate(routes.uploads())
      return
    }

    closeUploadSlider()
  }

  return (
    <ShipperSlider
      isOpen={isOpen}
      width="95vw"
      onClose={handleClosePanel}
      flush
      overflowHidden
    >
      <Suspense fallback={<Loading />}>
        <ShipmentUploadApp />
      </Suspense>
    </ShipperSlider>
  )
}
